import _ from 'lodash';
import {
  fnRun, set, getValue, curry, curryPartner,
} from './helpers';

export function Clamp(state, value, prop) {
  return _.clamp(value, fnRun(state, prop.range.min), fnRun(state, prop.range.max));
}

export function ClampPercent(state, value, prop) {
  return _.clamp(value / 100, fnRun(state, prop.range.min) / 100, fnRun(state, prop.range.max) / 100);
}

export function MemberContributions(state, value, prop) {
  /* eslint-disable new-cap */
  const clamped = ClampPercent(state, Math.round(value), prop);
  /* eslint-enable */
  return clamped > 0 && clamped < 0.02 ? 0.02 : clamped;
}

export function RoundedClamp(state, value, prop) {
  /* eslint-disable new-cap */
  return Clamp(state, Math.floor(value), prop);
  /* eslint-enable */
}

function fnWorking(modifier) {
  return function Working(state, working, prop) {
    const hasChangedSalary = getValue(state, `inferred.HasChangedSalary${modifier}`);

    if (working !== prop.value && !hasChangedSalary) {
      const salary = working ? 70000 : 0;

      set(state, {
        key: `inferred.Salary${modifier}`,
        value: salary,
        options: { skipAfterSet: true },
      });

      set(state, {
        key: `inputs.Salary${modifier}`,
        value: salary,
        options: { skipAfterSet: true },
      });
    }

    return working;
  };
}
export const Working = curry(fnWorking);
export const Working2 = curryPartner(fnWorking);
